import { Injectable } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class MxValidationService {
  constructor() {}

  static getValidatorError(code: string, validatorValue?: any) {
    let params;

    if (code === 'minlength') {
      params = [];
      params.push({ requiredLength: validatorValue.requiredLength });
    }

    if (code === 'maxlength') {
      params = [];
      params.push({ requiredLength: validatorValue.requiredLength });
    }

    return { message: code, params: params };
  }

  static creditCardValidator(control: AbstractControl) {
    // Visa, MasterCard, American Express, Diners Club, Discover, JCB
    // tslint:disable-next-line
    if (
      control.value?.match(
        /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/
      )
    ) {
      return null;
    } else {
      return { invalidCreditCard: true };
    }
  }

  static emailValidator(control: AbstractControl) {
    // RFC 2822 compliant regex
    // tslint:disable-next-line
    if (
      control.value?.match(
        /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/
      )
    ) {
      return null;
    } else {
      return { invalidEmailAddress: true };
    }
  }

  static passwordValidator(control: AbstractControl) {
    // {6,100}           - Assert password is between 6 and 100 characters
    // (?=.*[0-9])       - Assert a string has at least one number
    // (?!.*\s)          - Spaces are not allowed
    // control.value.match(/^(?=.*\d)(?=.*[a-zA-Z!@#$%^&*])(?!.*\s).{6,100}$/)
    // tslint:disable-next-line
    if (
      //Password should be atleast 8 characters long and should contain one number,one character and one special character
      control.value?.match(
        /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&+-.])[A-Za-z\d$@$!%*#?&+-.]{8,}$/
      )
    ) {
      return null;
    } else {
      return { invalidPassword: true };
    }
  }

  static acceptTermsValidator(control: AbstractControl) {
    if (control.value === true) {
      return null;
    } else {
      return { invalidAcceptTerms: true };
    }
  }

  static passwordMustMatchValidator(
    controlName: string,
    matchingControlName: string
  ) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors.passwordMustMatch) {
        // return if another validator has already found an error on the matchingControl
        return;
      }

      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ passwordMustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }
}
